const ZERO = 0;
const ONE = 1;
const TWO = 2;
const THREE = 3;
const FOUR = 4;
const SIX = 6;
const SEVEN = 7;
const NINE = 9;
const TEN = 10;
const TWELVE = 12;

const THIRTEEN = 13;

export const maskEmailAddress = (email: string) => {
  let response = email;
  if (email && email !== "") {
    const emailUnique = email.split("@")[ZERO];
    const emailUniqueEnd = email.split("@")[ONE];
    if (emailUnique.length > THREE) {
      response = emailUnique.substring(ZERO, THREE);
      for (let i = ZERO; i < emailUnique.length - THREE; i++) {
        response += "*";
      }
    } else {
      response = emailUnique.substring(ZERO, ONE);
      for (let i = ZERO; i < emailUnique.length - ONE; i++) {
        response += "*";
      }
    }

    if (
      emailUniqueEnd !== undefined &&
      emailUniqueEnd !== null &&
      emailUniqueEnd !== ""
    ) {
      response += `@${emailUniqueEnd}`;
    }
  }
  return response;
};

export const maskPhoneNumber = (phoneNumber: string) => {
  let response = phoneNumber;
  if (phoneNumber && phoneNumber !== "") {
    const phoneNumberEnd = phoneNumber.substring(phoneNumber.length - TWO);
    if (phoneNumber.length >= THIRTEEN) {
      response = phoneNumber.substring(ZERO, SEVEN);
      for (let i = ZERO; i < phoneNumber.length - NINE; i++) {
        response += "*";
      }
    } else if (phoneNumber.length >= NINE && phoneNumber.length <= TWELVE) {
      response = phoneNumber.substring(ZERO, FOUR);
      for (let i = ZERO; i < phoneNumber.length - SIX; i++) {
        response += "*";
      }
    } else {
      response = phoneNumber.substring(ZERO, TWO);
      for (let i = ZERO; i < phoneNumber.length - FOUR; i++) {
        response += "*";
      }
    }
    response += phoneNumberEnd;
  }
  return response;
};

export const maskRandomDigits = (randomNumber: string) => {
  let response = randomNumber;

  if (randomNumber && randomNumber !== "") {
    const length = randomNumber.length;

    if (length >= TEN) {
      // Mask for numbers with length >= 10
      const randomNumberEnd = randomNumber.substring(length - FOUR);
      response = randomNumber.substring(ZERO, THREE);
      for (let i = ZERO; i < length - SEVEN; i++) {
        response += "*";
      }
      response += randomNumberEnd;
    } else if (length >= FOUR) {
      // Mask for numbers with length >= 4 and < 10
      const randomNumberEnd = randomNumber.substring(length - TWO);
      response = randomNumber.substring(ZERO, TWO);
      for (let i = ZERO; i < length - FOUR; i++) {
        response += "*";
      }
      response += randomNumberEnd;
    } else {
      // Mask for numbers with length < 4
      response = randomNumber[ZERO]; // Show only the first digit
      for (let i = ONE; i < length; i++) {
        response += "*";
      }
    }
  }

  return response;
};
